/*
 * Public API Surface of capiche-logger
 */

export * from './lib/capiche-logger.config';
export * from './lib/capiche-logger.service';
